<template>
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    />
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

const converterConfig = parseAndValidateConverterConfig('raf-to-jpg-converter', 'Fujifilm RAF → JPG');

function handleBatchCreated(batchId: string) { console.log('[RAF to JPG] Batch created:', batchId); }
function handleJobCompleted(jobId: string) { console.log('[RAF to JPG] Job completed:', jobId); }
function handleBatchCleared() { console.log('[RAF to JPG] Batch cleared'); }
function handleError(error: Error) { console.error('[RAF to JPG] Error:', error); }
function handleCreditsUpdated(credits: number) { console.log('[RAF to JPG] Credits updated:', credits); }
</script>
